import React from "react";
import { DefaultFooter } from "@ant-design/pro-components";

export default () => (
  <DefaultFooter
    copyright="2025 Power By EDOCDATA"
    links={[
      {
        key: "icp",
        title: "京ICP备20010409号-9",
        href: "https://color-iv.com/",
        blankTarget: true,
      },
    ]}
  />
);
